// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"Button_menuButton__3Gvjf","arrow":"Button_arrow__3k8JD","buttonIcon":"Button_buttonIcon__27l58","primary":"Button_primary__7kF8h","outline":"Button_outline__hM2pr"};